import { render } from "./RequestItem.vue?vue&type=template&id=504da1a9&scoped=true"
import script from "./RequestItem.vue?vue&type=script&lang=js"
export * from "./RequestItem.vue?vue&type=script&lang=js"

import "./RequestItem.vue?vue&type=style&index=0&id=504da1a9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-504da1a9"

export default script